import { HELP_CENTER_CATEGORIES } from './help-center-topics';

/** Normalise titres FR (apostrophes typographiques, espaces) pour appariement catalogue ↔ API. */
export function normalizeHelpTitle(value: string): string {
  return value
    .normalize('NFC')
    .replace(/[\u2018\u2019\u201A\u2032]/g, "'")
    .replace(/[\u201C\u201D\u201E\u2033]/g, '"')
    .replace(/\u00a0/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

const TOPIC_TITLE_TO_ID: Map<string, string> = (() => {
  const map = new Map<string, string>();
  for (const cat of HELP_CENTER_CATEGORIES) {
    for (const topic of cat.topics) {
      map.set(normalizeHelpTitle(topic.title), topic.id);
    }
  }
  return map;
})();

const CATEGORY_TITLE_TO_ID: Map<string, string> = (() => {
  const map = new Map<string, string>();
  for (const cat of HELP_CENTER_CATEGORIES) {
    map.set(normalizeHelpTitle(cat.title), cat.id);
  }
  return map;
})();

/** Retrouve l’id catalogue (legacyTopicId) à partir du titre FR stocké en base. */
export function matchStaticHelpTopicIdByTitle(title: string): string | null {
  const hit = TOPIC_TITLE_TO_ID.get(normalizeHelpTitle(title));
  return hit ?? null;
}

export function matchStaticHelpCategoryIdByTitle(title: string): string | null {
  const hit = CATEGORY_TITLE_TO_ID.get(normalizeHelpTitle(title));
  return hit ?? null;
}

/**
 * Apparie un topic API au catalogue statique.
 * L’API peut exposer `title` en anglais alors que le catalogue est en FR :
 * on teste aussi titleI18n.fr (et les autres locales) avant d’abandonner.
 */
export function matchStaticHelpTopicId(
  title: string,
  titleI18n?: Record<string, string> | null,
): string | null {
  const candidates: string[] = [];
  const fr = titleI18n?.fr?.trim();
  if (fr) candidates.push(fr);
  if (title.trim()) candidates.push(title.trim());
  if (titleI18n) {
    for (const value of Object.values(titleI18n)) {
      const v = typeof value === 'string' ? value.trim() : '';
      if (v) candidates.push(v);
    }
  }
  const seen = new Set<string>();
  for (const candidate of candidates) {
    const key = normalizeHelpTitle(candidate);
    if (seen.has(key)) continue;
    seen.add(key);
    const hit = TOPIC_TITLE_TO_ID.get(key);
    if (hit) return hit;
  }
  return null;
}

export function matchStaticHelpCategoryId(
  title: string,
  titleI18n?: Record<string, string> | null,
): string | null {
  const candidates: string[] = [];
  const fr = titleI18n?.fr?.trim();
  if (fr) candidates.push(fr);
  if (title.trim()) candidates.push(title.trim());
  if (titleI18n) {
    for (const value of Object.values(titleI18n)) {
      const v = typeof value === 'string' ? value.trim() : '';
      if (v) candidates.push(v);
    }
  }
  const seen = new Set<string>();
  for (const candidate of candidates) {
    const key = normalizeHelpTitle(candidate);
    if (seen.has(key)) continue;
    seen.add(key);
    const hit = CATEGORY_TITLE_TO_ID.get(key);
    if (hit) return hit;
  }
  return null;
}
